if (!window.customElements.get("discount-countdown")) {
  var DiscountCountdown = class extends HTMLElement {
    constructor() {
      super();
      try {
        // 1. 安全获取属性
        this._endingTime = this.getAttribute("data-ending-time") || '';
        
        // 2. 安全获取DOM元素（带默认值）
        this._elements = {
          day: this.querySelector("[data-countdown-day]"),
          hour: this.querySelector("[data-countdown-hour]"),
          minute: this.querySelector("[data-countdown-minute]"),
          seconds: this.querySelector("[data-countdown-seconds]")
        };
        
        // 3. 初始化默认显示
        this._initDefaultDisplay();
        
      } catch (error) {
        console.error('DiscountCountdown init error:', error);
      }
    }

    connectedCallback() {
      // 4. 验证必要元素是否存在
      if (!this._validateElements()) {
        console.warn('DiscountCountdown: Required elements missing');
        return;
      }
      
      // 5. 验证时间格式
      if (!this._validateTime()) {
        this._showError("Invalid time format");
        return;
      }

      this._interval = setInterval(this._handleCountdown.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this._interval);
    }

    // 6. 元素验证方法
    _validateElements() {
      return Object.values(this._elements).every(el => el instanceof HTMLElement);
    }

    // 7. 时间验证方法
    _validateTime() {
      return !isNaN(new Date(this._endingTime).getTime());
    }

    // 8. 初始化默认显示
    _initDefaultDisplay() {
      Object.values(this._elements).forEach(el => {
        if (el) el.textContent = '00';
      });
    }

    // 9. 显示错误信息
    _showError(message) {
      console.error(message);
      this._initDefaultDisplay();
      this.style.color = 'red';
    }

    _formatNumber(num) {
      return num < 10 ? `0${num}` : num;
    }

    _handleCountdown() {
      try {
        const targetTime = new Date(this._endingTime).getTime();
        const currentTime = Date.now();
        const diffTime = targetTime - currentTime;

        // 10. 倒计时结束处理
        if (diffTime <= 0) {
          this._initDefaultDisplay();
          this.dispatchEvent(new Event('countdown-end'));
          clearInterval(this._interval);
          return;
        }

        // 11. 安全更新DOM
        const updateIfValid = (el, value) => {
          if (el && el.textContent !== value) {
            el.textContent = value;
          }
        };

        const day = Math.floor(diffTime / 86400000);
        const hours = Math.floor((diffTime % 86400000) / 3600000);
        const minutes = Math.floor((diffTime % 3600000) / 60000);
        const seconds = Math.floor((diffTime % 60000) / 1000);

        updateIfValid(this._elements.day, this._formatNumber(day));
        updateIfValid(this._elements.hour, this._formatNumber(hours));
        updateIfValid(this._elements.minute, this._formatNumber(minutes));
        updateIfValid(this._elements.seconds, this._formatNumber(seconds));

      } catch (error) {
        console.error('Countdown error:', error);
        clearInterval(this._interval);
      }
    }
  };

  window.customElements.define("discount-countdown", DiscountCountdown);
}
